module.exports = __webpack_public_path__ + "img/16_9.63a9d74b.png";